var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.433 5.34299L11.8096 4.68615L9.72917 0.563885C9.5481 0.205195 9.19963 0.026062 8.85106 0.026062C8.50205 0.026062 8.15358 0.205189 7.97296 0.563885L5.89209 4.68615L1.26869 5.34299C0.458693 5.45814 0.137667 6.44698 0.72747 7.00951L4.06355 10.1887L3.27263 14.6955C3.1622 15.3255 3.6665 15.8388 4.23988 15.8388C4.38932 15.8388 4.54293 15.8042 4.69237 15.7277L8.85112 13.5899L13.0099 15.7277C13.1588 15.8042 13.313 15.8388 13.4619 15.8388C14.0353 15.8388 14.5396 15.3255 14.4292 14.6955L13.6382 10.1887L16.9743 7.00951C17.5647 6.44698 17.2431 5.45816 16.4331 5.34299",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.377e67bc6ced5fe3c5068509090aa7a5.svg";
export { ForwardRef as ReactComponent };